import HomePage from "./homePage";

export { HomePage };
